import styled from 'styled-components'
import { Button } from 'antd'

export const AddButton = styled(Button)`
  margin-top: 16px;
`
